var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 17.476 17.476",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17.476v17.476H0z",
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.641 16.019a.73.73 0 0 1-.728-.728V2.184a.73.73 0 0 1 .728-.728h10.194a.73.73 0 0 1 .728.728v2.185h-1.456V2.912H4.369v11.65h8.738v-1.456h1.456v2.184a.73.73 0 0 1-.728.728zm9.466-4.369V9.466H8.013V8.009h5.1V5.825l3.641 2.913z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.50d9ecb02b4f1febdd743166adc1e402.svg";